module.exports = __webpack_public_path__ + "static/img/role.788a9d5.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/qa/role.png
// module id = a95t
// module chunks = 7